import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
const EnvContext = createContext(null);
export const EnvProvider = ({ env, children, }) => (_jsx(EnvContext.Provider, { value: env, children: children }));
export const useEnv = () => {
    const ctx = useContext(EnvContext);
    if (!ctx)
        throw new Error("useEnv must be used within EnvProvider (AppWrapper)");
    return ctx;
};
//# sourceMappingURL=EnvProvider.js.map